import { StatesModule, Transition } from '@uirouter/angular';
import { CustomerBillingNavigationTabsComponent } from '@fi-app/customer-billing/customer-billing-navigation-tabs/customer-billing-navigation-tabs.component';
import { Ng2StateDeclaration } from '@uirouter/angular';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { CustomerBillingCustomerViewComponent } from '@fi-app/customer-billing/customer-billing-customer/customer-billing-customer-view/customer-billing-customer-view.component';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { CustomerService } from '@fi-app/customer-billing/customer-billing-customer/customer.service';
import { CustomerBillingCustomerEditComponent } from '@fi-app/customer-billing/customer-billing-customer/customer-billing-customer-edit/customer-billing-customer-edit.component';
import { CustomerBillingCustomerUnitViewComponent } from '@fi-app/customer-billing/customer-billing-customer-unit/customer-billing-customer-unit-view/customer-billing-customer-unit-view.component';
import { CustomerBillingCustomerUnitEditComponent } from '@fi-app/customer-billing/customer-billing-customer-unit/customer-billing-customer-unit-edit/customer-billing-customer-unit-edit.component';
import { CustomerBillingInvoiceViewComponent } from '@fi-app/customer-billing/customer-billing-invoice/customer-billing-invoice-view/customer-billing-invoice-view.component';
import { InvoiceService } from '@fi-app/customer-billing/customer-billing-invoice/invoice.service';
import { CustomerBillingInvoiceEditStateComponent } from '@fi-app/customer-billing/customer-billing-invoice/customer-billing-invoice-edit-state/customer-billing-invoice-edit-state.component';
import { CustomerBillingOtherCustomerViewComponent } from '@fi-app/customer-billing/customer-billing-other-customer/customer-billing-other-customer-view/customer-billing-other-customer-view.component';
import { CustomerBillingOtherCustomerModel } from '@fi-app/customer-billing/customer-billing-other-customer/customer-billing-other-customer.model';
import { CustomerBillingOtherCustomerEditComponent } from '@fi-app/customer-billing/customer-billing-other-customer/customer-billing-other-customer-edit/customer-billing-other-customer-edit.component';
import { CustomerBillingResellerViewComponent } from '@fi-app/customer-billing/customer-billing-reseller/customer-billing-reseller-view/customer-billing-reseller-view.component';
import { fiCustomerType } from '@fi-app/customer-billing/customer-billing-customer/customer-type';
import { CustomerBillingResellerEditComponent } from '@fi-app/customer-billing/customer-billing-reseller/customer-billing-reseller-edit/customer-billing-reseller-edit.component';
import { CustomerBillingPriceArticleModel } from '@fi-app/customer-billing/customer-billing-price/customer-billing-price.model';
import { CustomerBillingPriceEditComponent } from '@fi-app/customer-billing/customer-billing-price/customer-billing-price-edit/customer-billing-price-edit.component';
import { CustomerBillingPriceService } from '@fi-app/customer-billing/customer-billing-price/customer-billing-price.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';
import { CustomerBillingCustomerListStateComponent } from '@fi-app/customer-billing/customer-billing-customer/customer-billing-customer-list/customer-billing-customer-list-state.component';
import { CustomerBillingCustomerUnitListStateComponent } from '@fi-app/customer-billing/customer-billing-customer-unit/customer-billing-customer-unit-list/customer-billing-customer-unit-list-state.component';
import { CustomerBillingInvoiceListStateComponent } from '@fi-app/customer-billing/customer-billing-invoice/customer-billing-invoice-list/customer-billing-invoice-list-state.component';
import { CustomerBillingOtherCustomerListStateComponent } from '@fi-app/customer-billing/customer-billing-other-customer/customer-billing-other-customer-list/customer-billing-other-customer-list-state.component';
import { CustomerBillingResellerListStateComponent } from '@fi-app/customer-billing/customer-billing-reseller/customer-billing-reseller-list/customer-billing-reseller-list-state.component';
import { CustomerBillingPriceListStateComponent } from '@fi-app/customer-billing/customer-billing-price/customer-billing-price-list/customer-billing-price-list-state.component';

const CustomerBillingState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling._name,
    url: '/CustomerBilling',
    component: CustomerBillingNavigationTabsComponent,
    abstract: true,
};
export function CustomerBillingModuleModel() {
    return {
        listData: null,
    };
}

/*--- Customer routes */
const CustomerBillingCustomersState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.Customers._name,
    url: '/Customer',
    component: FiAbstractStateComponent,
};

const CustomerBillingCustomerListState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.Customers.List,
    url: '/List?:sortColumn&:sortDirection&:offset',
    component: CustomerBillingCustomerListStateComponent,
    reloadOnSearch: false,
    resolve: {
        pageTitle: [PageTitleService, CustomerBillingCustomerListPageTitle],
    },
};
export function CustomerBillingCustomerListPageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitle('Customer list');
}

const CustomerBillingCustomerViewState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.Customers.View,
    url: '/View/:Id',
    resolve: {
        customer: [FiStateService, Transition, CustomerService, CustomerBillingCustomerViewCustomer],
        resellers: [CustomerService, CustomerBillingCustomerViewResellers],
        pageTitle: [PageTitleService, CustomerBillingCustomerViewPageTitle],
    },
    views: {
        '@Module': {
            component: CustomerBillingCustomerViewComponent,
        },
    },
};
export function CustomerBillingCustomerViewCustomer(
    stateService: FiStateService,
    transition: Transition,
    CustomerService: CustomerService,
) {
    return CustomerService.GetCustomer(stateService.getParams(transition).Id);
}
export function CustomerBillingCustomerViewResellers(CustomerService: CustomerService) {
    return CustomerService.GetResellers();
}
export function CustomerBillingCustomerViewPageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitle('Customer view');
}

const CustomerBillingCustomerEditState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.Customers.Edit,
    url: '/:Id/Edit',
    views: {
        '@Module': {
            component: CustomerBillingCustomerEditComponent,
        },
    },
    resolve: {
        customer: [FiStateService, Transition, CustomerService, CustomerBillingCustomerViewCustomer],
        resellers: [CustomerService, CustomerBillingCustomerViewResellers],
        pageTitle: [PageTitleService, CustomerBillingCustomerEditPageTitle],
    },
};
export function CustomerBillingCustomerEditPageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitle('Customer Edit');
}

/*--- CustomerUnits routes */

const CustomerBillingCustomerUnitsState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.CustomerUnits._name,
    url: '/CustomerUnits',
    abstract: true,
    component: FiAbstractStateComponent,
};

const CustomerBillingCustomerUnitsListState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.CustomerUnits.List,
    url: '/List?:sortColumn&:sortDirection&:offset',
    component: CustomerBillingCustomerUnitListStateComponent,
    reloadOnSearch: false,
    resolve: {
        pageTitle: [PageTitleService, CustomerBillingCustomerUnitsPageTitle],
    },
};
export function CustomerBillingCustomerUnitsPageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitle('Customer Units List');
}

const CustomerBillingCustomerUnitViewState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.CustomerUnits.View,
    url: '/View/:UnitId/:CustomerId',
    resolve: {
        customer: [FiStateService, '$transition$', CustomerService, CustomerBillingCustomerUnitViewCustomer],
        resellers: [CustomerService, CustomerBillingCustomerUnitViewResellers],
        pageTitle: [PageTitleService, CustomerBillingCustomerUnitViewPageTitle],
    },
    views: {
        '@Module': {
            component: CustomerBillingCustomerUnitViewComponent,
        },
    },
};
export function CustomerBillingCustomerUnitViewCustomer(
    stateService: FiStateService,
    transition: Transition,
    CustomerService: CustomerService,
) {
    return CustomerService.GetCustomerUnit(
        stateService.getParams(transition).CustomerId,
        stateService.getParams(transition).UnitId,
    );
}
export function CustomerBillingCustomerUnitViewResellers(CustomerService: CustomerService) {
    return CustomerService.GetResellers();
}
export function CustomerBillingCustomerUnitViewPageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitle('Customer unit view');
}

const CustomerBillingCustomerUnitEditState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.CustomerUnits.Edit,
    url: '/:CustomerId/:UnitId/Edit',
    views: {
        '@Module': {
            component: CustomerBillingCustomerUnitEditComponent,
        },
    },
    resolve: {
        customer: [FiStateService, Transition, CustomerService, CustomerBillingCustomerUnitViewCustomer],
        resellers: [CustomerService, CustomerBillingCustomerUnitViewResellers],
        pageTitle: [PageTitleService, CustomerBillingCustomerUnitEditPageTitle],
    },
};
export function CustomerBillingCustomerUnitEditPageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitle('Customer Edit');
}

/*--- Invoice routes ---*/
const CustomerBillingInvoiceState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.Invoice._name,
    url: '/Invoices',
    abstract: true,
    component: FiAbstractStateComponent,
};

const CustomerBillingInvoiceListState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.Invoice.List,
    url: '/List?:sortColumn&:sortDirection&:offset',
    component: CustomerBillingInvoiceListStateComponent,
    reloadOnSearch: false,
    resolve: {
        pageTitle: [PageTitleService, CustomerBillingInvoiceListPageTitle],
    },
};
export function CustomerBillingInvoiceListPageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitle('Invoice List');
}

const CustomerBillingInvoiceViewState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.Invoice.View,
    url: '/View/:Id',
    views: {
        '@Module': {
            component: CustomerBillingInvoiceViewComponent,
        },
    },
    resolve: {
        invoice: [InvoiceService, FiStateService, '$transition$', CustomerBillingInvoiceViewInvoice],
        pageTitle: [PageTitleService, CustomerBillingInvoiceViewPageTitle],
    },
};
export function CustomerBillingInvoiceViewInvoice(
    InvoiceService: InvoiceService,
    stateService: FiStateService,
    transition,
) {
    return InvoiceService.GetInvoice(stateService.getParams(transition).Id);
}
export function CustomerBillingInvoiceViewPageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitle('Invoice View');
}

const CustomerBillingInvoiceAddState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.Invoice.Add,
    url: '/Add',
    views: {
        '@Module': {
            component: CustomerBillingInvoiceEditStateComponent,
        },
    },
    resolve: {
        invoice: [InvoiceService, CustomerBillingInvoiceAddInvoice],
        pageTitle: [PageTitleService, CustomerBillingInvoiceAddPageTitle],
        customers: [CustomerService, CustomerBillingInvoiceAddCustomers],
    },
};
export function CustomerBillingInvoiceAddInvoice(InvoiceService: InvoiceService) {
    return InvoiceService.CreateInvoice();
}
export function CustomerBillingInvoiceAddPageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitle('Create Invoice');
}
export function CustomerBillingInvoiceAddCustomers(customerService: CustomerService) {
    const customersSearchParameterModel = {
        CustomerType: null,
        Names: [],
        SelectedSort: {
            ColumnName: 'Name',
            SortDirection: false,
        },
        Offset: 0,
        NumberOfRecordsToTake: 10000,
    };

    return Promise.all([
        customerService.GetCustomers(customersSearchParameterModel),
        customerService.GetOtherBillingCustomers(customersSearchParameterModel),
    ]).then(function (responses) {
        return responses[0].concat(responses[1]);
    });
}

const CustomerBillingInvoiceEditState = {
    name: FiStateNames.CustomerBilling.Invoice.Edit,
    url: '/:Id/Edit',
    views: {
        '@Module': {
            component: CustomerBillingInvoiceEditStateComponent,
        },
    },
    resolve: {
        invoice: [InvoiceService, FiStateService, Transition, CustomerBillingInvoiceEditInvoice],
        pageTitle: [PageTitleService, CustomerBillingInvoiceEditPageTitle],
        customers: [CustomerService, CustomerBillingInvoiceAddCustomers],
    },
};
export function CustomerBillingInvoiceEditInvoice(
    InvoiceService,
    stateService: FiStateService,
    transition: Transition,
) {
    return InvoiceService.GetInvoice(stateService.getParams(transition).Id);
}
export function CustomerBillingInvoiceEditPageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitle('Invoice Edit');
}

/*--- Other customers ---*/
const CustomerBillingOtherCustomersState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.OtherCustomers._name,
    url: '/OtherCustomers',
    abstract: true,
    component: FiAbstractStateComponent,
};

const CustomerBillingOtherCustomersListState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.OtherCustomers.List,
    url: '/List?:sortColumn&:sortDirection&:offset',
    component: CustomerBillingOtherCustomerListStateComponent,
    reloadOnSearch: false,
    resolve: {
        pageTitle: [PageTitleService, CustomerBillingOtherCustomersList_pageTitle],
    },
};
export function CustomerBillingOtherCustomersList_pageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitle('Other Customer List');
}

const CustomerBillingOtherCustomersViewState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.OtherCustomers.View,
    url: '/{Id:[0-9]+}',
    views: {
        '@Module': {
            component: CustomerBillingOtherCustomerViewComponent,
        },
    },
    resolve: {
        customer: [CustomerService, FiStateService, Transition, CustomerBillingOtherCustomersView_customer],
        resellers: [CustomerService, CustomerBillingOtherCustomersView_resellers],
        pageTitle: [PageTitleService, CustomerBillingOtherCustomersView_pageTitle],
    },
};
export function CustomerBillingOtherCustomersView_customer(
    CustomerService: CustomerService,
    stateService: FiStateService,
    transition: Transition,
) {
    return CustomerService.GetOtherBillingCustomer(stateService.getParams(transition).Id);
}
export function CustomerBillingOtherCustomersView_resellers(CustomerService: CustomerService) {
    return CustomerService.GetResellers();
}
export function CustomerBillingOtherCustomersView_pageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitle('Other Customer View');
}

const CustomerBillingOtherCustomersAddState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.OtherCustomers.Add,
    url: '/Add',
    views: {
        '@Module': {
            component: CustomerBillingOtherCustomerEditComponent,
        },
    },
    resolve: {
        customer: [CustomerBillingOtherCustomersAdd_customer],
        resellers: [CustomerService, CustomerBillingOtherCustomersView_resellers],
        pageTitle: [PageTitleService, CustomerBillingOtherCustomersAdd_pageTitle],
    },
};
export function CustomerBillingOtherCustomersAdd_customer() {
    return new CustomerBillingOtherCustomerModel();
}
export function CustomerBillingOtherCustomersAdd_pageTitle(ccmPageTitle) {
    return ccmPageTitle.setTitle('Create Other customer');
}

const CustomerBillingOtherCustomersEditState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.OtherCustomers.Edit,
    url: '/{Id:[0-9]+}/Edit',
    views: {
        '@Module': {
            component: CustomerBillingOtherCustomerEditComponent,
        },
    },
    resolve: {
        customer: [CustomerService, FiStateService, '$transition$', CustomerBillingOtherCustomersEdit_customer],
        resellers: [CustomerService, CustomerBillingOtherCustomersView_resellers],
        pageTitle: [PageTitleService, CustomerBillingOtherCustomersEdit_pageTitle],
    },
};
export function CustomerBillingOtherCustomersEdit_customer(CustomerService, stateService: FiStateService, transition) {
    return CustomerService.GetOtherBillingCustomer(stateService.getParams(transition).Id);
}
export function CustomerBillingOtherCustomersEdit_pageTitle(ccmPageTitle) {
    return ccmPageTitle.setTitle('Other Customer Edit');
}

/*--- Resellers ---*/
const CustomerBillingResellersState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.Resellers._name,
    url: '/Resellers',
    abstract: true,
    component: FiAbstractStateComponent,
};

const CustomerBillingResellersListState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.Resellers.List,
    url: '/List?:sortColumn&:sortDirection&:offset',
    component: CustomerBillingResellerListStateComponent,
    reloadOnSearch: false,
    resolve: {
        pageTitle: [PageTitleService, CustomerBillingResellersListStateResolvePageTitle],
    },
};
export function CustomerBillingResellersListStateResolvePageTitle(pageTitleService: PageTitleService) {
    return pageTitleService.setTitle('Resellers List');
}

const CustomerBillingResellersViewState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.Resellers.View,
    url: '/{Id:[0-9]+}',
    views: {
        '@Module': {
            component: CustomerBillingResellerViewComponent,
        },
    },
    resolve: {
        customer: [CustomerService, FiStateService, Transition, CustomerBillingResellersView_customer],
        pageTitle: [PageTitleService, CustomerBillingResellersView_pageTitle],
    },
};
export function CustomerBillingResellersView_customer(
    CustomerService: CustomerService,
    stateService: FiStateService,
    transition: Transition,
) {
    return CustomerService.GetOtherBillingCustomer(stateService.getParams(transition).Id);
}
export function CustomerBillingResellersView_pageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitle('Resellers View');
}

const CustomerBillingResellersAddState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.Resellers.Add,
    url: '/Add',
    views: {
        '@Module': {
            component: CustomerBillingResellerEditComponent,
        },
    },
    resolve: {
        customer: [CustomerBillingResellersAdd_customer],
        pageTitle: [PageTitleService, CustomerBillingResellersAdd_pageTitle],
    },
};
export function CustomerBillingResellersAdd_customer() {
    return new CustomerBillingOtherCustomerModel({ IsReseller: true, CustomerType: fiCustomerType.Reseller });
}
export function CustomerBillingResellersAdd_pageTitle(ccmPageTitle) {
    return ccmPageTitle.setTitle('Resellers Add');
}

const CustomerBillingResellersEditState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.Resellers.Edit,
    url: '/{Id:[0-9]+}/Edit',
    views: {
        '@Module': {
            component: CustomerBillingResellerEditComponent,
        },
    },
    resolve: {
        customer: [CustomerService, FiStateService, '$transition$', CustomerBillingResellersView_customer],
        pageTitle: [PageTitleService, CustomerBillingResellersEdit_pageTitle],
    },
};
export function CustomerBillingResellersEdit_pageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitle('Resellers Edit');
}

/*--- Prices ---*/
const CustomerBillingPriceState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.Price._name,
    url: '/Prices',
    abstract: true,
    component: FiAbstractStateComponent,
};

const CustomerBillingPriceListState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.Price.List,
    url: '/List?:sortColumn&:sortDirection&:offset',
    component: CustomerBillingPriceListStateComponent,
    reloadOnSearch: false,
    resolve: {
        pageTitle: [PageTitleService, CustomerBillingPriceList_pageTitle],
    },
};
export function CustomerBillingPriceList_pageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitle('Price List');
}

const CustomerBillingPriceAddState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.Price.Add,
    url: '/Add',
    resolve: {
        priceArticle: [CustomerBillingPriceAdd_price],
        pageTitle: [PageTitleService, CustomerBillingPriceAdd_pageTitle],
    },
    views: {
        '@Module': {
            component: CustomerBillingPriceEditComponent,
        },
    },
};
export function CustomerBillingPriceAdd_price() {
    return new CustomerBillingPriceArticleModel();
}
export function CustomerBillingPriceAdd_pageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitle('Create Price');
}

const CustomerBillingPriceEditState: Ng2StateDeclaration = {
    name: FiStateNames.CustomerBilling.Price.Edit,
    url: '/{Id:[0-9]+}/{ModuleId:[0-9]+}/Edit',
    resolve: {
        priceArticle: [
            FiStateService,
            Transition,
            CustomerBillingPriceService,
            CustomerBillingPriceEditStateResolvePrice,
        ],
        pageTitle: [PageTitleService, CustomerBillingPriceEditStateResolvePageTitle],
    },
    views: {
        '@Module': {
            component: CustomerBillingPriceEditComponent,
        },
    },
};
export function CustomerBillingPriceEditStateResolvePrice(
    stateService: FiStateService,
    transition: Transition,
    PriceService: CustomerBillingPriceService,
) {
    return PriceService.GetBillingPrice(
        stateService.getParams(transition).Id,
        stateService.getParams(transition).ModuleId,
    );
}
export function CustomerBillingPriceEditStateResolvePageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitle('Edit Price');
}

export const CustomerBillingStates: StatesModule = {
    states: [
        CustomerBillingCustomersState,
        CustomerBillingState,
        CustomerBillingCustomerListState,
        CustomerBillingCustomerViewState,
        CustomerBillingCustomerEditState,
        CustomerBillingCustomerUnitsState,
        CustomerBillingCustomerUnitsListState,
        CustomerBillingCustomerUnitViewState,
        CustomerBillingCustomerUnitEditState,
        CustomerBillingInvoiceState,
        CustomerBillingInvoiceListState,
        CustomerBillingInvoiceViewState,
        CustomerBillingInvoiceAddState,
        CustomerBillingInvoiceEditState,
        CustomerBillingOtherCustomersState,
        CustomerBillingOtherCustomersListState,
        CustomerBillingOtherCustomersViewState,
        CustomerBillingOtherCustomersAddState,
        CustomerBillingOtherCustomersEditState,
        CustomerBillingResellersState,
        CustomerBillingResellersListState,
        CustomerBillingResellersViewState,
        CustomerBillingResellersAddState,
        CustomerBillingResellersEditState,
        CustomerBillingPriceState,
        CustomerBillingPriceListState,
        CustomerBillingPriceAddState,
        CustomerBillingPriceEditState,
    ],
};
